import React from "react";

export default function SQL_Sum() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Sum</h1>
      <p>This is the SQL_Sum component generated from the SQL JSON.</p>
    </div>
  );
}
